
export default loginInfo => {
	const { authType, menu } = loginInfo

	// console.log('loginInfo:', loginInfo)
	return authType === 'auth' ? { menu: menu.filter(o => o.startsWith('/TyanLims/')) } : {}
}